<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.3098 7.92871C14.275 7.92871 13.4361 8.7676 13.4361 9.80241V11.2823L18.5646 11.2823L18.5646 9.8024C18.5646 8.76759 17.7257 7.92871 16.6909 7.92871H15.3098ZM20.5646 11.2823L20.5646 9.8024C20.5646 7.66302 18.8303 5.92871 16.6909 5.92871L15.3098 5.92871C13.1704 5.92871 11.4361 7.66302 11.4361 9.80241V11.2823H9.29481C8.2135 11.2823 7.33691 12.1589 7.33691 13.2402L7.33691 20.3395C7.33691 24.066 10.3578 27.0869 14.0843 27.0869H17.9159C21.6424 27.0869 24.6633 24.066 24.6633 20.3395V13.2402C24.6633 12.1589 23.7867 11.2823 22.7054 11.2823H20.5646ZM9.33691 13.2823V20.3395C9.33691 22.9614 11.4624 25.0869 14.0843 25.0869H17.9159C20.5378 25.0869 22.6633 22.9614 22.6633 20.3395V13.2823L9.33691 13.2823ZM17.0001 16.4207V21.2748H15.0001V16.4207H17.0001Z"
        />
    </svg>
</template>
